var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewCalendar = function SvgNewCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17.5px",
    height: "17.5000001px",
    viewBox: "0 0 17.5 17.5000001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.1.5-Health-screening-/-Upcoming---expand-filter-added",
    transform: "translate(-427.250000, -206.250000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-Copy-4",
    transform: "translate(256.000000, 186.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rigth-filter-ver-2",
    transform: "translate(20.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(148.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,3.24999996 C17.345178,3.24999996 17.625,3.52982199 17.625,3.87499996 L17.625,4.49999996 L18.25,4.49999996 C19.5754834,4.49999996 20.6600386,5.5315359 20.7446823,6.83562428 L20.75,6.99999996 L20.75,18.25 C20.75,19.6307119 19.6307119,20.75 18.25,20.75 L5.74999996,20.75 C4.36928809,20.75 3.24999996,19.6307119 3.24999996,18.25 L3.24999996,6.99999996 C3.24999996,5.61928809 4.36928809,4.49999996 5.74999996,4.49999996 L6.37499996,4.49999996 L6.37499997,3.87499996 C6.37499997,3.52982199 6.654822,3.24999996 6.99999998,3.24999996 C7.34517795,3.24999996 7.62499998,3.52982199 7.62499998,3.87499996 L7.62499996,4.49999996 L16.375,4.49999996 L16.375,3.87499996 C16.375,3.52982199 16.6548221,3.24999996 17,3.24999996 Z M19.5,8.87499996 L4.49999996,8.87499996 L4.49999996,18.25 C4.49999996,18.8972087 4.99187463,19.4295339 5.62219473,19.4935464 L5.74999997,19.5 L18.25,19.5 C18.940356,19.5 19.5,18.940356 19.5,18.25 L19.5,8.87499996 Z M18.25,5.74999997 L5.74999997,5.74999997 C5.05964403,5.74999997 4.49999996,6.30964403 4.49999996,6.99999998 L4.49999996,7.62499996 L19.5,7.62499996 L19.5,6.99999998 C19.5,6.35279128 19.0081254,5.82046607 18.3778053,5.75645358 L18.25,5.74999997 Z",
    id: "Combined-Shape"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-calendar.a33d3fc5.svg";
export { ForwardRef as ReactComponent };